document.addEventListener("DOMContentLoaded", function () {
    $(".preview-pdf-button").on("click", function(){
        $('#documentPreviewModal').modal('show');
        if($("#textarea").length > 0){
            loadPdf($("#textarea").val())
        } else {
            loadPdf()
        }
    })
})

let loadPdfPending = false;

function loadPdf(textareaContent) {
    if(loadPdfPending) return;
    loadPdfPending = true;
    let previedDocument;
    $('#documentPreviewModal .load-spinner').show();

    fetch("/process/imported-document", {
        method: 'POST',
        body: JSON.stringify({content: textareaContent || ""}),
        headers: { "Content-Type": "application/json" },
        credentials: "include",
    }).catch((err) => console.error(err))
    .then(response => {
        return response.json();
    })
    .then(result => {
        previedDocument = result.document;
        const previewElement = document.getElementById('pdfPreview');

        const pdfjsLib = window['pdfjs-dist/build/pdf'];
        pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';

        for (let index = 0; index < previedDocument.files.length; index++) {
            const file = previedDocument.files[index];
            let currPage = 1; //Pages are 1-based not 0-based
            let numPages = 0;
            let pdfDocument = null;

            function handlePages(page) {
                if(index === 0 && currPage === 1) {
                    if (previewElement) previewElement.innerHTML = '';
                } 

                var canvas = document.createElement("canvas");
                var context = canvas.getContext('2d');

                const viewport = page.getViewport({ scale: 1 })

                canvas.height = viewport.height;
                canvas.width = viewport.width;
                canvas.style.width = viewport.width;

                page.render({ canvasContext: context, viewport: viewport });

                previewElement.appendChild(canvas);

                var canvasHover = document.createElement("canvas");
                var contextHover = canvasHover.getContext('2d');

                canvasHover.height = viewport.height;
                canvasHover.width = viewport.width;
                canvasHover.style.width = viewport.width;

                page.render({ canvasContext: contextHover, viewport: viewport });

                currPage++;
                if (pdfDocument !== null && currPage <= numPages) {
                    return pdfDocument.getPage(currPage).then(handlePages);
                }
            }

            setTimeout(() => {
                pdfjsLib.getDocument(file).promise
                    .then(pdf => {
                        pdfDocument = pdf;
                        numPages = pdf.numPages;
                        return pdf.getPage(currPage).then(handlePages)
                            .then(() => {
                                const ratio = $('.pdf-preview').width() / $('.pdf-preview canvas').width()
                                if (ratio >= 1 || ratio == 0) return;
                                $('.pdf-preview canvas').css({
                                    transform: `scale(${ratio})`,
                                    'margin-left': `auto`,
                                    'margin-right': `auto`,
                                    'margin-top': `-${($('.pdf-preview canvas').height() - $('.pdf-preview canvas').height() * ratio) / 2}px`,
                                    'margin-bottom': `-${($('.pdf-preview canvas').height() - $('.pdf-preview canvas').height() * ratio)}px`
                                });
            
                                $('.pdf-preview').css({ height: `${$('.pdf-preview canvas').height() * ratio}px` })
                            })
                    })
                    .catch(console.error)
                    .finally(() => {
                        loadPdfPending = false;
                        if(index === previedDocument.files.length - 1){
                            $('#documentPreviewModal .load-spinner').hide();
                        }
                    })
            }, index*500);
        }
    })
}